export const SERVER_PUSH_EVENTS = {
  projectStatusChanged: "project.status.changed",
  projectDeleted: "project.deleted",
  variantRiskCalcStatusChanged: "variant.riskcalc.status.changed",
};
